import { useParams } from "react-router-dom";
import Loader from "src/components/Loader";
import ProposalView from "src/components/view/Proposal.view";
import { useGET } from "src/hooks/useApi";
import Proposal from "src/types/Proposal.type";
import usePageView from "../../../hooks/usePageView";

export default function ViewProposalPage() {
  const params = useParams();
  const url = `res/proposal/${params.id}`;
  const { data, isLoading, error } = useGET<Proposal>(url);

  usePageView("proposal");
  return (
    <Loader isLoading={isLoading} error={error} hasData={!!data}>
      <ProposalView proposal={data} />
    </Loader>
  );
}
